import { useCallback, useState } from "react";
import useJsonApi from "lib/useJsonApi.js";

function useAddOrderItems(appointmentUuid, orderNumber) {
  const [request, setRequest] = useState({});

  const response = useJsonApi({
    url: request.url,
    method: "POST",
    body: request.body,
  });

  const addItem = useCallback(
    (items) => {
      setRequest({
        url: `/api/order/${encodeURIComponent(
          appointmentUuid
        )}/${encodeURIComponent(orderNumber)}/add-items`,
        body: { items },
      });
    },
    [appointmentUuid, orderNumber]
  );

  return [addItem, response];
}

export default useAddOrderItems;
